import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AccountCaptchaSettings, AccountSettingsCaptchaComponent } from '@volo/abp.ng.account/admin';

import { AppModule } from './app/app.module';
import { ExternalAuthBootstrapModule } from './app/external-bootstrap/external-auth-bootstrap.module';
import { shouldBootstrapExternalAuth } from './app/external-bootstrap/external-auth-bootstrap.utils';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

AccountSettingsCaptchaComponent.prototype.mapTenantSettingsForSubmit = function (
  newSettings: Partial<AccountCaptchaSettings>
) {
  return {
    version: newSettings.version,
    siteKey: newSettings.siteKey,
    siteSecret: newSettings.siteSecret,
    score: newSettings.score,
  };
};

const bootstrapModule = shouldBootstrapExternalAuth(window.location.pathname, window.location.search)
  ? ExternalAuthBootstrapModule
  : AppModule;

platformBrowserDynamic().bootstrapModule(bootstrapModule)
  .catch(err => console.error(err));
